import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import ReactTable from 'react-table';
import ReactTooltip from 'react-tooltip';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import ApplicationMessageDetailsModal from './ApplicationMessageDetailsModal';
import Logger, { LOG_LEVELS } from '../../utils/logger';
import Pagination from '../page/Pagination';
import { closeHandler, getMessageStatus } from './messagesHelper';
//TODO: to be removed with s-dash 2 migration
import { SDashAlertCloseButton } from '../helper/sdash-pollyfills';
import { ApplicationMessagesIcons } from './ApplicationMessagesIcons';

const log = new Logger('APPLICATION_MESSAGE_COLLECTION', LOG_LEVELS.DEBUG);

const MessageCell = (props) =>{
  return (
    <div>
      <span data-tip={props.value} data-testid='reason-tooltip'>
        {props.value}
        <ReactTooltip/>
      </span>
    </div>
  );
}

const DefaultErrorDetailViewComponent = (props) => {
  const defaultColumns = [
    props.setColumnWidth
      ? {
          Header: (props) => <LanguageStringResolver string={'applicationMessageWithDetail_Id'}></LanguageStringResolver>,
          accessor: 'id',
          filterable: true,
          maxWidth: 100,
        }
      : { Header: (props) => <LanguageStringResolver string={'applicationMessageWithDetail_Id'}></LanguageStringResolver>, accessor: 'id', filterable: true },
    {
      Header: (props) => <LanguageStringResolver string={'applicationMessageWithDetail_Reason'}></LanguageStringResolver>,
      accessor: 'message',
      filterable: true,
      Cell: MessageCell
    },
  ];

  const cols = Array.isArray(props.columns) ? props.columns : defaultColumns;
  const errorDetail = Array.isArray(props.data) ? props.data : [];
  const defaultTableOptions = {
    minRows: 10,
    defaultPageSize: 10,
  };
  const tableOptions = props.tableOptions ? Object.assign({}, props.tableOptions, defaultTableOptions) : defaultTableOptions;
  return (
    <div>
      <ReactTable
        data={errorDetail}
        columns={cols}
        defaultFilterMethod={(filter, row) => String(row[filter.id]).includes(filter.value)}
        {...tableOptions}
        PaginationComponent={Pagination}
      />
    </div>
  );
};

class ApplicationMessageWithDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      messageDetailsModalOpenList: new Map(),
    };
    this.messageDetailsModalCloseClickHandler = this.messageDetailsModalCloseClickHandler.bind(this);
    this.openMessageDetailsModal = this.openMessageDetailsModal.bind(this);
    this.closeMessageDetailsModal = this.closeMessageDetailsModal.bind(this);
    this.messageClickHandler = this.messageClickHandler.bind(this);
    this.getModalState = this.getModalState.bind(this);
  }

  openMessageDetailsModal(key) {
    let newOpenList = new Map(this.state.messageDetailsModalOpenList);
    newOpenList.set(key, true);
    this.setState({
      messageDetailsModalOpenList: newOpenList,
    });
  }

  closeMessageDetailsModal(key) {
    let newOpenList = new Map(this.state.messageDetailsModalOpenList);
    newOpenList.set(key, false);
    this.setState({
      messageDetailsModalOpenList: newOpenList,
    });
  }

  messageDetailsModalCloseClickHandler(key) {
    return () => {
      this.closeMessageDetailsModal(key);
    };
  }

  messageClickHandler(key) {
    return () => {
      this.openMessageDetailsModal(key);
    };
  }

  getModalState(key) {
    if (this.state.messageDetailsModalOpenList.has(key)) {
      return this.state.messageDetailsModalOpenList.get(key);
    } else {
      return false;
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.messages !== prevProps.messages) {
      this.setState({
        messageDetailsModalOpenList: new Map(),
      });
    }
  }

  render() {
    const messageStatus = getMessageStatus(this.props.messageType);
    const messageDetails = _.isEmpty(this.props.messageDetails)
      ? []
      : _.isArray(this.props.messageDetails)
      ? this.props.messageDetails
      : [this.props.messageDetails];
    log.debug('render(): ', this.props);
    return (
      <div>
        {this.props.messages.map((entry, index) => {
          return (
            <s-alert onClick={this.messageClickHandler(index)} key={index} status={messageStatus} s-dismiss={closeHandler(entry, log)} role="alert">
              <ApplicationMessagesIcons messageStatus={messageStatus} />
              <span className="clickable">
                <LanguageStringResolver string={entry.message.languageString} tooltip={entry.message.extendedLanguageString} params={entry.args} />
              </span>
              <SDashAlertCloseButton onClose={closeHandler(entry, log)} />
              <ApplicationMessageDetailsModal
                titleLanguageString={this.props.titleLanguageString}
                open={this.getModalState(index)}
                onCloseClick={this.messageDetailsModalCloseClickHandler(index)}
              >
                {this.props.errorDetailViewComponent ? (
                  <div>{this.props.errorDetailViewComponent}</div>
                ) : (
                  <DefaultErrorDetailViewComponent data={messageDetails} />
                )}
              </ApplicationMessageDetailsModal>
            </s-alert>
          );
        })}
      </div>
    );
  }
}


ApplicationMessageWithDetail.defaultProps = {
  messageDetails: [],
  setColumnWidth: true,
};

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): ', state, props);
  const inAppMessages = (state.logger && state.logger.inAppMessages) || [];
  const types = props.messageType;
  const scopes = Array.isArray(props.scopes) ? props.scopes : typeof props.scopes === 'string' ? [props.scopes] : undefined;
  const messageIds = Array.isArray(props.messageIds) ? props.messageIds : typeof props.messageIds === 'number' ? [props.messageIds] : undefined;
  const messages = inAppMessages.filter((entry) => {
    return (
      entry.message &&
      (!types || types.indexOf(entry.message.type) >= 0) &&
      (!scopes || scopes.indexOf(entry.scope) >= 0) &&
      (!messageIds || messageIds.indexOf(entry.message.id) >= 0)
    );
  });
  const messagesByType = messages.reduce((byType, entry) => {
    if (!entry && !entry.message) {
      return byType;
    }
    if (!byType[entry.message.type]) {
      byType[entry.message.type] = [];
    }
    byType[entry.message.type].push(entry);
    return byType;
  }, {});
  return {
    messages,
    messagesByType,
  };
}

export default connect(mapStateToProps)(ApplicationMessageWithDetail);
